<template>
    <div>
        <div class="query-content">
            <van-nav-bar title="客服查询" @click-left="goCheck" left-text="返回" left-arrow></van-nav-bar>
            <!--<div class="page-title">流量使用量及状态查询</div>-->
            <div class="page-content">
                <fieldset class="md-field">
                    <div class="md-field-item-content">
                        <label class="md-field-item-title">设备操作</label>
                        <div class="md-field-item-control">
                            <a v-if="operator.imeiBind==1" @click="resetImei">设备重绑</a>
                            <a v-clipboard:copy="iccid" v-clipboard:success="onCopySuccess"
                               v-clipboard:error="onCopyError">复制号码</a>
                            <a v-if="operator.authUrl" :href="operator.authUrl">活体实名</a>
                            <a @click="refresh">刷新</a>
                            <!--<a @click="handleWxUnbind">微信解绑</a>-->
                        </div>
                    </div>
                    <div class="md-field-item-content">
                        <label class="md-field-item-title">查询设备</label>
                        <div class="md-field-item-control" >
                            <input id="copy_phone" :value="iccid" disabled>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="md-field"><!---->
                    <div class="md-field-content">
                        <van-progress :percentage="leftPercent"  stroke-width="36" />
                    </div>
                </fieldset>
                <fieldset class="md-field"><!---->
                    <div class="md-field-content">
                        <div class="card-state md-tab-bar">
                            <div class="flow-item">
                                <div class="item-title">设备状态</div>
                                <div class="item-content">
                                    <!--<span class="dot-gray state-dot"></span>-->
                                    <span>{{simStatusName}}</span></div>
                            </div>
                            <div class="split"></div>
                            <div class="flow-item">
                                <div class="item-title">实名状态</div>
                                <div class="item-content">
                                    <span>{{simAuthStatusName}}</span>
                                </div>
                            </div>
                        </div>
                    </div> <!----></fieldset>

                <fieldset class="md-field">
                    <div class="md-field-content">
                        <div class="card-state md-tab-bar">
                            <div class="flow-item" :style="{color:'#409EFF'}">
                                <div class="item-title"  :style="{color:'#409EFF'}">总共</div>
                                <div class="item-content">
                                    <!--<span class="dot-gray state-dot"></span>-->
                                    <span>{{totalUsage}}G</span></div>
                            </div>
                            <div class="split"></div>
                            <div class="flow-item"  :style="{color:'#F56C6C'}">
                                <div class="item-title"  :style="{color:'#F56C6C'}">剩余</div>
                                <div class="item-content">
                                    <span>{{remainUsage}}G</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>

                <fieldset class="package-list md-field">
                    <template v-if="packageList.length > 0">
                        <p v-for="(item,index) in packageList" :key="index" :style="{fontSize:'.3rem'}">
                            <span>{{item.package.title}}</span>
                            <span>{{item.startDate}}至{{item.endDate}}</span>
                        </p>
                    </template>
                    <p v-else :style="{color:'#F56C6C',fontSize:'.3rem'}">
                        请点击下方按钮，续费套餐后以畅享网络
                    </p>
                </fieldset>
                <!--<fieldset class="md-field">
                    <div class="md-field-content">
                        <button type="button" @click="handleRechargeBtnClick" class="md-button primary active block">
                            <div class="md-button-inner">
                                <div class="md-button-content"><span>续费套餐</span></div>
                            </div>
                        </button>
                    </div>
                </fieldset>-->

            </div>
        </div>
        <div class="warm-tips"><h5>说明</h5>
            <ol>
                <li>设备状态显示正常无法正常上网查找设备设置及本地信号问题</li>
                <li>显示停机查看下方套餐是否已经用完。如没有套餐请续费</li>
                <li>显示停机。还有套餐应考虑是更换设备造成。请联系客服（提供新设备的IMEI码）</li>
            </ol>
        </div>
        <van-action-sheet
                v-model="cardModal"
                :actions="cardlist"
                cancel-text="取消"
                @select="handleChooseCard"
        />
        <van-dialog
                v-model="inputImeiModal"
                title="输入IMEI"
                show-cancel-button
                @confirm="handleImeiInput"
        >
            <van-cell-group>
                <van-field v-model="imei" type="number" placeholder="请输入设备IMEI"/>
            </van-cell-group>
        </van-dialog>
    </div>
</template>

<script>

    import Vue from "vue";
    import VueClipboard from 'vue-clipboard2'
    Vue.use(VueClipboard)
    export default {
        name: "index",
        // components: {PackageInfo, swiper, swiperSlide},
        data() {
            return {
                iccid: '',
                cardModal: false,
                inputImeiModal: false,
                imei: '',
                /*swiperOption: {
                    centeredSlides: true,
                    slidesPerView:2,
                    spaceBetween : 80,
                    slidesOffsetBefore:-40
                },*/
                cardlist: [],
                packageList: [],
                /*currentPackage: {
                     total:0,
                     used:0,
                     startDate:'--',
                     endDate:'--'
                 },
                 nextPackage: {
                    total:0,
                    used:0,
                    startDate:'--',
                    endDate:'--'
                },*/
                totalUsage:0,
                remainUsage:0,
                simStatusName: '',
                simAuthStatus: '',
                unbindNeedImei: 0,
                operator: {},
            };
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper
            },
            simAuthStatusName() {
                return this.simAuthStatus == 1 ? '已实名' : '未实名'
            },
            leftPercent(){
                if(this.totalUsage > 0){
                    return parseInt(this.remainUsage / this.totalUsage * 100);
                }else{
                    return 0;
                }
            },
            pivotText(){
                return "剩余流量"+this.remainUsage+'G，总流量'+this.totalUsage+'G，剩余比例 '+this.leftPercent+'%'
            }
        },
        watch: {
            iccid(value) {
                sessionStorage.setItem('iccid', this.iccid)
                this.queryPackageList();
                this.queryOperatorInfo();
                this.queryCardStatus();
                this.queryResetImeiType()
            }
        },
        created: function () {
            if(!this.$route.query.iccid){
                this.$toast.fail('非法设备号')
            }else{
                this.iccid = this.$route.query.iccid
            }
        },
        methods: {
            goCheck(){
                this.$router.push({name:'customerCheck'})
            },
            handleRechargeBtnClick() {
                this.$router.push({name: 'recharge', query: {iccid: this.iccid}})
            },
            /*onBuyCurrent() {
                this.$router.push({name: "recharge", query: {iccid: this.iccid, type: 0}})
            },
            onBuyNext() {
                this.$router.push({name: "recharge", query: {iccid: this.iccid, type: 1}})
            },*/
            queryOperatorInfo() {
                this.fetchData('/Customercard/cardOperator', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.operator = res.data
                    }
                })
            },
            queryPackageList() {
                this.$toast.loading({message: '加载中'});
                this.fetchData('/Customerpackage/monthlist', {iccid: this.iccid}, (res) => {
                    this.$toast.clear()
                    if (res.code) {
                        this.packageList = res.data
                    } else {
                        this.$toast.fail('查询失败');
                    }
                })
            },
            queryCardStatus() {
                this.fetchData('/Customercard/status', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.simStatusName = res.data.simStatusName;
                        this.simAuthStatus = res.data.simAuthStatus;
                        this.totalUsage = res.data.total;
                        this.remainUsage = res.data.remain
                        if(!this.simAuthStatus && this.operator.authUrl){
                            this.$dialog.confirm({
                                title: '实名提示',
                                message: '未查询到设备的实名信息，点击确定去实名'
                            }).then(() => {
                                // on confirm
                                window.location.href = this.operator.authUrl
                            }).catch(() => {
                                // on cancel
                            });
                        }
                    }
                })
            },
            refresh(){
                this.queryPackageList();
                this.queryCardStatus();
            },
            queryResetImeiType() {
                this.fetchData('/Customercard/resetImeiType', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.unbindNeedImei = res.data
                    }
                })
            },
            resetImei() {
                if (this.unbindNeedImei == 0) {
                    //不需要上报imei
                    this.$toast.loading('解绑中')
                    this.fetchDataPost('/Customercard/active', {iccid: this.iccid}, (res) => {
                        this.$toast.clear();
                        if (res.code) {
                            this.$toast.success(res.msg)
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    })

                } else {
                    this.inputImeiModal = true;
                }
            },
            handleImeiInput() {
                if (!this.imei) {
                    this.$toast.fail('请输入IMEI');
                    this.close()
                } else {
                    this.fetchDataPost('/Customercard/resetImei', {iccid: this.iccid, imei: this.imei}, (res) => {
                        if (res.code) {
                            this.inputImeiModal = false;
                            this.$toast.success(res.msg)
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    })
                }
            },
            handleChooseCard(row) {
                this.iccid = row.value;
                this.cardModal = false;
            },
            handleWxUnbind() {
                this.$dialog.confirm({
                    message: '解绑后需重新绑定才能查询续费，确认解绑？'
                }).then(() => {
                    this.fetchDataPost('/Customercard/unbindwx', {iccid: this.iccid}, (res) => {
                        if (res.code) {
                            this.$toast.success(res.msg)
                            this.queryUserCards()
                        } else {
                            this.$toast.fail(res.msg)
                        }
                    })
                }).catch(() => {
                    console.log('cancel')
                });
            },
            onCopySuccess() {
                this.$toast.success('复制成功')
            },
            onCopyError() {
                this.$toast.fail('复制失败');
            }
        }
    };
</script>
<style lang="scss">
    .md-button {
        display: block;
        height: 1rem;
        line-height: 1rem;
        font-size: 0.36rem;
        font-weight: 500;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
        text-align: center;
        box-sizing: border-box;
        -webkit-appearance: none;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        border-radius: 0.04rem;
        outline: 0px;
        transition: all 0.3s ease 0s;
        overflow: visible;
        position: relative;
    }


    .md-button.primary {
        background: #2f86f6;
        color: #fff;
    }

    .md-button.block {
        width: 100%;
    }

    .md-button.inactive {
        opacity: .3;
    }

    .md-button-inner {
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        word-wrap: break-word;
        white-space: nowrap;
    }

    .query-content {
        background: #fff;
        font-size: .12rem;
        margin: .2rem auto;
        -webkit-box-shadow: 0 0 1px #dedede;
        box-shadow: 0 0 1px #dedede;
        border-radius: .1rem;
    }

    .package-list p span {
        line-height: 2;

        &:first-child {
            float: left;
        }

        &:last-child {
            float: right;
        }
    }

    .query-content .page-title {
        margin: .3rem 0 0 0;
        font-size: .3rem;
        height: .8rem;
        line-height: .8rem;
        border-radius: .2rem .2rem 0 0;
        border-bottom: 1px solid #fafafa;
        color: #888;
        text-align: center;
    }

    .page-content {
        padding-bottom: .1rem;
        min-height: 6rem;
        border-radius: 0 0 .2rem .2rem;
        background: #fff;
    }

    .md-field {
        padding: .1rem .2rem;
        border: none;
    }

    .package-list {
        margin-top: .1rem;
    }

    .md-input-item-input {
        width: 100%;
        height: 1rem;
        color: rgb(17, 26, 52);
        font-size: 0.32rem;
        font-weight: 500;
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
        line-height: 1;
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;
        -webkit-appearance: none;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        background: 0px 0px;
        outline: 0px;
    }

    imei-input {
        width: 4.8rem;
        text-align: center !important;
    }

    .md-field-item-content {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        justify-content: space-between;
        min-height: 1rem;
        /*padding-top: .3rem;
        padding-bottom: .3rem;*/
        box-sizing: border-box;
        border-bottom: 1px solid #ccc;
    }

    .md-field-item-title {
        text-align: left;
        width: 1.6rem;
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
        font-size: .32rem;
    }

    .md-field-item-control {
        text-align: left;
        position: relative;
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 0%;
        flex: 1 1 0%;
        color: #111a34;
        font-size: .32rem;
        font-weight: 500;
        padding: 0;
        margin: 0;
        line-height: 1.15;
        border: none;
        background: none;
        outline: none;
        border: 0;
    }

    .md-field-item-control a {
        margin: 0 .1rem;
        font-size: .26rem;
        color: #3a8ee6;
        white-space: nowrap;
    }

    #copy_phone {
        border: none;
        font-weight: 500;
        width: 100%;
        height: .36rem;
        font-size: .32rem;
        user-select: none;
    }

    #copy_phone:disabled {
        background: none;
    }

    .md-field-item-right {
        position: relative;
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
        margin-left: .12rem;
        display: -webkit-inline-box;
        display: -webkit-inline-flex;
        display: inline-flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        -webkit-box-pack: end;
        -webkit-justify-content: flex-end;
        justify-content: flex-end;
        color: #858b9c;
        font-size: .28rem;
    }


    .card-state {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        padding: .2rem 0 .1rem 0;
    }

    .card-state .flow-item {
        font-size: .36rem;
        text-align: center;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
    }

    .card-state .split {
        border-left: 1px solid #fafafa;
        min-height: .4rem;
    }

    .card-state .flow-item .item-title {
        color: #888;
        font-size: .34rem;
    }

    .md-tab-bar {
        position: relative;
        padding-left: .4rem;
        padding-right: .4rem;
        background-color: #f9fafb;
    }

    .dot-gray {
        position: relative;
    }

    .card-state .flow-item .item-content .state-dot {
        margin-top: .08rem;
    }

    .dot-gray:after {
        content: "";
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        -webkit-box-shadow: 0 0 0.1rem #888 inset;
        box-shadow: inset 0 0 0.1rem #888;
    }

    /*.dot-gray:after {
        width: .12rem;
        height: .12rem;
        background-color: #888;
        border-radius: 50%;
    }*/
</style>



// WEBPACK FOOTER //
// src/pages/customer/checkInfo.vue